import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-stamp-ui',
  templateUrl: './stamp-ui.component.html',
  styleUrls: ['./stamp-ui.component.css'],
})
export class StampUiComponent implements OnInit {
  @Input() companyName: string = '';
  @Input() registrationNo: string = '';
  @Input() location: string = '';
  @Input() stampImage: string = '';
  @Output() stampChanged = new EventEmitter<string>();

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Check file size (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        alert('File size must be less than 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target?.result as string;
        this.stampChanged.emit(base64String);
      };
      reader.readAsDataURL(file);
    }
  }

  constructor() {}

  ngOnInit(): void {}
}
